module.exports = __webpack_public_path__ + "img/GHS08.4771c565.gif";